import { saveAs } from 'file-saver';
import http from '../../core/services/http';

const exportOpportunities = () =>
  http
    .get('/partner/quotes/export', { responseType: 'blob' })
    .then(response => saveAs(response.data, `Opportunities.xlsx`));

export default exportOpportunities;
